import gql from "graphql-tag";

export const MARK_USER_BY_FIGMA = gql`
  mutation ($id: String!) {
    markUserByFigmaPlugin(id: $id) {
      email
    }
  }
`;
